exports.f = {}.propertyIsEnumerable;


/*****************
 ** WEBPACK FOOTER
 ** ./~/.2.4.1@core-js/library/modules/_object-pie.js
 ** module id = 76
 ** module chunks = 0 1
 **/